export var FeatureFlag;
(function (FeatureFlag) {
    FeatureFlag["GuestExperience"] = "FF_guest-experience";
    FeatureFlag["OLEPhoneConsent"] = "FF_ole-phone-consent";
    FeatureFlag["SPOGWebUI"] = "FF_SPOG_WEB_UI";
    FeatureFlag["MFAEmailSunset"] = "FF_email-sunset";
    FeatureFlag["CardNGA"] = "FF_card-nga";
    FeatureFlag["AutoNGA"] = "FF_auto-nga";
    FeatureFlag["LegacyAAOSOLE"] = "FF_legacy-aaos-ole";
})(FeatureFlag || (FeatureFlag = {}));
//# sourceMappingURL=FeatureFlagEnum.js.map